"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hr = _interopRequireDefault(require("../../hr"));

var _topNav = require("./top-nav.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NavLinks = function NavLinks(_ref) {
  var _ref$activeLink = _ref.activeLink,
      activeLink = _ref$activeLink === void 0 ? '' : _ref$activeLink,
      _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? [] : _ref$routes,
      _ref$keyboardNav = _ref.keyboardNav,
      keyboardNav = _ref$keyboardNav === void 0 ? true : _ref$keyboardNav,
      _ref$onMobile = _ref.onMobile,
      onMobile = _ref$onMobile === void 0 ? false : _ref$onMobile;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, routes.map(function (link) {
    return link.mobileOnly && !onMobile ? null : /*#__PURE__*/_react["default"].createElement("li", {
      key: link.url
    }, /*#__PURE__*/_react["default"].createElement(_topNav.NavLink, {
      href: link.url,
      tabIndex: keyboardNav ? 0 : -1,
      active: link.url === activeLink
    }, link.text), onMobile ? /*#__PURE__*/_react["default"].createElement(_hr["default"], null) : null);
  }));
};

NavLinks.propTypes = {
  activeLink: _propTypes["default"].string,

  /* Whether this NavLink is rendering via <MobileNav /> */
  onMobile: _propTypes["default"].bool,

  /* Array of links to populate */
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string,
    url: _propTypes["default"].string,
    active: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool,
    mobileOnly: _propTypes["default"].bool,
    openInNewTab: _propTypes["default"].bool
  })),

  /* Whether the links should be navigable by keyboard. Used to "hide" unexpanded mobile dropdown */
  keyboardNav: _propTypes["default"].bool
};
var _default = NavLinks;
exports["default"] = _default;